export default __webpack_public_path__ + "static/media/misc-bathtubA-1920w.e0b30319.png";